import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import avatarTest from '../images/others/avatar.png';
import { Helmet } from 'react-helmet';
import { Responsive, WidthProvider } from "react-grid-layout";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import Analytic from 'components/widgets/Analytic';
import { useCallback, useMemo, useState } from 'react';
import { NoData } from 'components/NoData';
import Profile from 'components/widgets/Profile';
import ReportDash from 'components/widgets/Report';
import Salesplan from 'components/widgets/Salesplan';
import Tasks from 'components/widgets/Tasks';
import { Typography } from '@mui/material';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { EditWidjetsSelector } from 'store/slices/editWidjets';
import { loginSelector } from 'store/slices/loginSlice';
import SubHeaderClient from 'components/SubHeaderDashboardClient';
import Statuses from 'components/widgets/Statuses';
import Magazine from 'components/widgets/magazine';
import ProductStorage from 'components/widgets/ProductsStorage';
import ProductStocks from 'components/widgets/ProductsStocks';
import { getDataSource } from 'api/ds';
// @ts-ignore
import { ReportTable } from 'components/reportTable';
import { MarketClientSelector } from 'store/slices/marketClient';
import { get } from "api/apiBridges/httpBridge"
import { useLocalNotifications } from "components/Events";
import Scrollbars from 'rc-scrollbars';

const ResponsiveReactGridLayout = WidthProvider(Responsive);

// данные для тестов
const profileData = { name: 'elena', avatar: avatarTest, get: { value: 120, lastMonth: { value: 130, trend: 'up' } }, clients: { value: 20, lastMonth: { value: 30, trend: 'down' } } };

const dataAnalitic = [{ data: 'Новые заявки', value: 100, all: 180, format: 'сделки' }, { data: 'Договора', value: 10, all: 100, format: 'сделки' }, { data: 'Ожидает передачи', value: 80, all: 180, format: 'сделки' }];

// todo название полей
const dataTask = [{ nameTask: 'task1', progress: 77, subTasks: [{ nameTask: 'subTask1', check: true }, { nameTask: 'subTask2', check: false }] },
{ nameTask: 'task2', progress: 10, subTasks: [{ nameTask: 'subTask1', check: true }, { nameTask: 'subTask2', check: false }] }];

const dataReport = { "key": "value", "key1": "value1", "key2": "value2" };

const dataMagazine = { magazine: "ozone", fbs: 100, fbo: 10, sku: 86, saveTovar: 56, countTovar: 170, transferTovar: 120 };

const dataStatuses = ['emerald', 'silver', 'gold', 'firstClient', 'deals100'];

const dataProductStorage = { locations: ['Коледино', 'Подольск', 'Электросталь', 'Шушары'], products: [{ name: 'Футболки', count: [0, 11, 12, 0] }] }

const SalesplanData = {
    "otdel_vedeniya": { purpose: 30000, now: 20000, format: 'руб', users: [{ "elena": { purpose: 30000, now: 10000, avatar: avatarTest, format: 'руб' } }, { "elena1": { purpose: 3000, now: 10, avatar: avatarTest, format: 'руб' } }] },
    "otdel_vedeniya1": { purpose: 30000, now: 30000, format: 'ед', users: [{ "elena12121212": { purpose: 30000, now: 10000, avatar: avatarTest, format: 'ед' } }, { "elena1": { purpose: 3000, now: 10, avatar: avatarTest, format: 'ед' } }] }
};

// выбор виджета
function Widget({ param, data, load }) {
    console.log("widjet", load)
    switch (param) {
        case 'analytic':
            return (<Analytic data={dataAnalitic}></Analytic>);
        case 'profile':
            return (<Profile data={profileData}></Profile>);
        case 'report':
            return (<ReportDash data={dataReport}></ReportDash>);
        case 'salesPlan':
            return (<Salesplan data={SalesplanData}></Salesplan>);
        case 'tasks':
            return (<Tasks data={dataTask}></Tasks>);
        case 'statuses':
            return (<Statuses data={dataStatuses}></Statuses>);
        case 'magazine':
            return (<Magazine data={dataMagazine}></Magazine>);
        case 'productStorage':
            return (<ProductStorage data={dataProductStorage}></ProductStorage>);
        case 'productStocks':
            return (<ProductStocks data={data} load={load}></ProductStocks>);
        default:
            return <NoData></NoData>
    }
}

export default function Dashboard() {
    // глобальная переменная редакса, потому что кнопка позволяющая включать перемещения виджетов в заголовке
    const { editWidjets } = useSelector(EditWidjetsSelector);
    // переменная для вкл/выкл перемещением виджетов
    const [isDrag, setIsDrag] = useState(false);
    const { role } = useSelector(loginSelector);
    const { market } = useSelector(MarketClientSelector);
    console.log("market", market)
    //Пожалуй тут надо добавить загрузку инфы о пользователе
    //Где будет добавляться загрузка инфы для дашбордов?
    
    const { user_id} = useSelector(
        loginSelector
    );

    useEffect(() => {
        setIsDrag(editWidjets);
    }, [editWidjets])

    // под каждый виджет свои размеры и позиция
    // const [widgetArray, setWidgetArray] = useState([]);

    const [data, setData] = useState(
        {productStocks: {}}
    )
    const [load, setLoad] = useState(
        {productStocks: true}
    )
    const dsProductStocksData = useMemo(() => getDataSource('ProductTotalCount'), []);

    const { showNotification } = useLocalNotifications();
    //Тут добавлять методы загрузки данных
    const fetchDataProductStocks = useCallback(async () => {
        let tempLoad = {...load}
        tempLoad.productStocks = true
        setLoad(tempLoad);
        let res = undefined
        let isToken = await get('Clients/checkClientAPIKey', {uid:user_id, market:market})
        console.log('IS TOKEN', isToken)
        console.log("market", market)
        switch (market) {
            case "wb":
                if (isToken){
                    res = await dsProductStocksData.GetWBCardWithStocksAndStorage(user_id);
                }else {
                    showNotification({
                        id: 'checkToken', 
                        type: 'error', 
                        message: 'У вас не указан API ключ.' 
                    });
                }        
                break;
            case "ozon":
                if (isToken){
                    res = await dsProductStocksData.GetOZONCardWithStocksAndStorage(user_id);
                }else {
                    showNotification({
                        id: 'checkToken', 
                        type: 'error', 
                        message: 'У вас не указан API ключ.' 
                    });
                }        
                break;
            case "custom":
                res = await get("custom_product/get_card_with_stocks_and_storage", {cid:user_id})
                break;
        }
        
        console.log("MARKETDATA", res)

        //кусок для получегия остатков по размерам
        if (res) {

            res.map((el) => {
                let stocks = {total: el.data.totalCount, stocks:[]}
                let inRoad = {total: el.data.totalInRoad, stocks:[]}
                let storage = {total: el.data.totalStorage, stocks:[]}
                let sizes = {title: el.data.vendorCode, items: []}  
                el.data.sizes = el.data.sizes.sort((a, b) => a.title.localeCompare(b.title));               
                el.data.sizes.map((size) => {
                    // stocks.stocks.push({name:size.title, stocks:size.total})
                    // inRoad.stocks.push({name:size.title, stocks:size.totalInRoad})
                    // storage.stocks.push({name:size.title, stocks:size.storage})
                    stocks.stocks.push({stocks:size.total})
                    inRoad.stocks.push({stocks:size.totalInRoad})
                    storage.stocks.push({stocks:size.storage})
                    sizes.items.push(size.title)
                })
                el.sizes = sizes
                el.countOnSizes = stocks
                el.inRoadOnSizes = inRoad
                el.storageOnSize = storage
            })
        }
        ///

        let tempData = {...data}
        tempData.productStocks = res
        setData(tempData)
        tempLoad.productStocks = false
        setLoad(tempLoad);
    }, [market, user_id]);

    useEffect(() => {
        if (role === 'client') {
            fetchDataProductStocks();
            // setWidgetArray(
            //     [
            //         { i: "productStocks", x: 0, y: 0, w: 5.5, h: 1.2 },
            //     ]
            // )
        }
    }, [market, user_id]);


    

    // изменнеия позиционирования
    // @ts-ignore
    // const handleModify = (layouts, layout) => {
    //     const tempArray = widgetArray;
    //     layouts?.map((position) => {
    //         tempArray[Number(position.i)].x = position.x;
    //         tempArray[Number(position.i)].y = position.y;
    //         tempArray[Number(position.i)].width = position.w;
    //         tempArray[Number(position.i)].height = position.h;
    //     });
    //     setWidgetArray(tempArray);
    // };

    switch (role) {
        case "client":
            return (
                <div style={{display: "flex", flexDirection: "column", alignItems:"center", width: '100%', marginRight: "2%",height: '100%', overflow: 'hidden'}}>
                    <Scrollbars
                        autoHide
                        style={{ width: '100%', height: '100%'}} 
                        renderTrackVertical={props => <div {...props} style={{ ...props.style, right: 0 }} />}
                    >
                        <SubHeaderClient></SubHeaderClient>
                        <div style={{width: "96%", margin: "5% 2% 5% 2%"}}>
                            <ProductStocks data={data.productStocks} load={load.productStocks}></ProductStocks>
                        </div>
                    </Scrollbars>
                </div>
            )
        case "admin":
        case "manager":
            // setWidgetArray(
            //     [// { i: "analytic", x: 3.0, y: 0, w: 3.0, h: 1.8 },
            //     // { i: "profile", x: 0, y: 0, w: 3.0, h: 1.2 },
            //     // { i: "productStorage", x: 3.0, y: 2.4, w: 6.0, h: 2.8 },
            //     // // { i: "salesPlan", x: 3.0, y: 2.4, w: 3.0, h: 2.8 },
            //     // // { i: "tasks", x: 6.0, y: 0, w: 3.0, h: 1.6 },
            //     // { i: "magazine", x: 6.0, y: 0, w: 3.0, h: 2.0 },
            //     // //{ i: "statuses", x: 3.0, y: 0, w: 6.0, h: 1.2 },
            //     // { i: "report", x: 0, y: 2.4, w: 3.0, h: 1.6 },
            //     ]
            // )
            return (
                <>
                    <
// @ts-ignore
                    Helmet>
                        <title>Dashboard</title>
                    </Helmet>
                    <Box sx={{ width: '100%', height: '100%', flexGrow: 1 }}>
                        <Grid container rowSpacing={1} columnSpacing={0} columns={{ xs: 1, sm: 8, md: 12, lg: 12 }}>
                            <Grid item xs={1} sm={8} md={9} lg={9}>
                                {/* <ResponsiveReactGridLayout
                                    onLayoutChange={handleModify}
                                    verticalCompact={true}
                                    breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }}
                                    preventCollision={false}
                                    cols={{ lg: 9, md: 6, sm: 3, xs: 3, xxs: 3 }}
                                    autoSize={true}
                                    margin={{
                                        lg: [20, 20],
                                        md: [20, 20],
                                        sm: [20, 20],
                                        xs: [20, 20],
                                        xxs: [20, 20],
                                    }}
                                >
                                    {widgetArray?.map((widget, index) => {
                                        return (
                                            <div
                                                style={isDrag ? { opacity: "0.6" } : {}}
                                                className="reactGridItem"
                                                key={index}
                                                data-grid={{
                                                    x: widget?.x,
                                                    y: widget?.y,
                                                    w: widget?.w,
                                                    h: widget?.h,
                                                    i: widget.i,
                                                    minW: 1,
                                                    maxW: Infinity,
                                                    minH: 1,
                                                    maxH: Infinity,
                                                    isDraggable: isDrag,
                                                    isResizable: false,
                                                }}
                                            >

                                                <div style={isDrag ? { pointerEvents: "none" } : {}}><Widget param={widget.i} data={{}} load={false}></Widget></div>
                                            </div>
                                        );
                                    })}
                                </ResponsiveReactGridLayout> */}
                            </Grid>
                            <Grid item xs={1} sm={8} md={3} lg={3}>
                                <div style={{ backgroundColor: 'white', width: '100%', height: '100%' }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <Typography variant="h3">Новости</Typography>

                                    </div>
                                    <p>news</p>
                                </div>
                            </Grid>
                        </Grid>

                    </Box>
                </>
            )
    }
}